import { getAnalytics } from "firebase/analytics";
import { useContext } from "react";
import { SellarSessionContext } from "../contexts/SellarSessionContext";
import { firebaseApp } from "../firebaseApp";

export const analytics = getAnalytics(firebaseApp);

export const useSellarUser = () => {
  const context = useContext(SellarSessionContext);
  if (context === undefined) {
    throw new Error("useSellarUser must be within SellarSessionProvider");
  }

  return context.sellar;
};
